var _a, _b, _c, _d, _e, _f, _g;
import { __decorate, __metadata } from "tslib";
import { StoreItemTypeEnum } from '@goparrot/storeitems-sdk';
import { Expose } from 'class-transformer';
import { ArrayUnique, IsArray, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { MenuSyncConfigExposeGroup } from '../interface';
export class ReadWhiteListPropsDto {
}
_a = StoreItemTypeEnum.ITEM_SET, _b = StoreItemTypeEnum.CATEGORY, _c = StoreItemTypeEnum.STORE_ITEM, _d = StoreItemTypeEnum.ITEM_OPTIONS, _e = StoreItemTypeEnum.ITEM_BASE, _f = StoreItemTypeEnum.STORE_ITEM_GROUP, _g = StoreItemTypeEnum.COMBO;
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, _a, void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, _b, void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, _c, void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, _d, void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, _e, void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, _f, void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, _g, void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, "uniqueNames", void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadWhiteListPropsDto.prototype, "storeItemCopyProps", void 0);
//# sourceMappingURL=ReadWhiteListPropsDto.js.map